import { Component, OnInit } from '@angular/core';
import { faApple, faPaypal, faGooglePay } from '@fortawesome/free-brands-svg-icons';
import { faPencil, faLock } from '@fortawesome/pro-light-svg-icons';
import { ClickEvent } from "angular-star-rating";

@Component({
  selector: 'up-tip-cart',
  templateUrl: './tip.component.html',
  styleUrls: [ './tip.component.scss' ]
})
export class TipComponent implements OnInit {
  employeeRating = 1;
  selectedOption: number | 'custom' = 15;
  customAmount: number | null = null;
  faApple = faApple;
  faGooglePay = faGooglePay;
  faPaypal = faPaypal;
  faPencil = faPencil;
  faLock = faLock;
  isProcessing = false;
  isSuccess = false;
  isProcessingPaypal = false;
  isSuccessPaypal = false;

  ngOnInit(): void {}

  get finalTipAmount(): number {
    if (this.selectedOption === 'custom') {
      return this.customAmount || 0;
    }
    return this.selectedOption;
  }

  selectPreset(amount: number): void {
    this.selectedOption = amount;
    this.customAmount = null;
  }

  selectCustom(): void {
    this.selectedOption = 'custom';
  }

  onCustomAmountChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = parseFloat(input.value);

    if (!isNaN(value)) {
      this.customAmount = value;
      this.selectedOption = 'custom';
    } else {
      this.customAmount = null;
    }
  }

  isOptionSelected(option: number | 'custom'): boolean {
    return this.selectedOption === option;
  }

  onStarClicked($event: ClickEvent) {

  }

  processPrimaryPayment() {
    this.isProcessing = true;
    // Simulate API Call
    setTimeout(() => {
      this.isProcessing = false;
      this.isSuccess = true;
      // Reset or Navigate after showing success
      setTimeout(() => this.isSuccess = false, 3000);
    }, 2500);
  }

  processPaypalPayment() {
    this.isProcessingPaypal = true;
    setTimeout(() => {
      this.isProcessingPaypal = false;
      this.isSuccessPaypal = true;
      setTimeout(() => this.isSuccessPaypal = false, 3000);
    }, 2500);
  }

  getDeviceType(): 'android' | 'ios' | 'other' {
    const ua = navigator.userAgent.toLowerCase();
    if (/android/.test(ua)) return 'android';
    if (/iphone|ipad|ipod/.test(ua)) return 'ios';
    return 'other';
  }
}
